import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/site";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);   // null = checking, false = guest, obj = logged in
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges session_id first — skip the /me check
    if (window.location.hash?.includes("session_id=")) { setReady(true); return; }
    const token = localStorage.getItem("ff_token");
    if (!token) { setUser(false); setReady(true); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data.user))
      .catch(() => { localStorage.removeItem("ff_token"); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ff_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, type = "creator") => {
    const { data } = await api.post("/auth/register", { name, email, password, type });
    localStorage.setItem("ff_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const googleAuth = async (sessionId, role = "fan") => {
    const { data } = await api.post("/auth/google", { session_id: sessionId, role });
    localStorage.setItem("ff_token", data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("ff_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, googleAuth, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};
